<h1>Add Category <button type="button" (click)="CloseModal()" class="btn btn-default float-right">Close</button></h1>
<div class="row">
    <div class="col-sm-8 border-right">
        <form [formGroup]="categoryModalForm" (submit)="submitCategory()">
            <div class="form-group">
                <div class="row">
                    <div class="col-md-12 mt-5">
                        <label class="form-label">Lab Test Category *</label>
                        <input type="text" formControlName="lab_test_category" class="form-control"/>
                        <div *ngIf="submitted && f.lab_test_category.errors" class="invalid-feedback">
                            <div *ngIf="f.lab_test_category.errors.required">Lab Test Category is required</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-footer">
                <button type="submit" [disabled]="loading" class="btn btn-primary" ><i *ngIf="loading" class="fa fa-spin fa-spinner"></i> Submit</button>
            </div>
        </form>
    </div>
</div>
